// Accelerating creators: use avg_views ÷ followers
export const getAcceleratingCreators = (creators, threshold = 0.5) =>
  creators.filter(c => {
    const ratio = (c.avg_views || 0) / (c.followers || 1);
    return ratio > threshold;
  });

// Beauty niche growth % (compare avg_views vs last week)
export const getBeautyGrowth = (creators, history) => {
  const beautyCreators = creators.filter(c => (c.niche || "").toLowerCase().includes("beauty"));
  const avgCurrent = beautyCreators.reduce((acc, c) => acc + (c.avg_views || 0), 0) / (beautyCreators.length || 1);

  const beautyHistory = history.filter(h => (h.niche || "").toLowerCase().includes("beauty"));
  const avgPrev = beautyHistory.reduce((acc, h) => acc + (h.avg_views || 0), 0) / (beautyHistory.length || 1);

  const growthPct = Math.round(((avgCurrent - avgPrev) / (avgPrev || 1)) * 100);
  return { growthPct, creators: beautyCreators };
};

// FMCG matches: check audience, notes
export const getFMCGMatches = (creators) =>
  creators.filter(c =>
    (c.audience || "").toLowerCase().includes("fmcg") ||
    (c.notes || "").toLowerCase().includes("fmcg")
  );

// POV vs Storytelling
export const getPOVvsStorytelling = (creators) => {
  const povCreators = creators.filter(c => (c.top_hook || "").toLowerCase().includes("pov"));
  const storytellingCreators = creators.filter(c => (c.top_hook || "").toLowerCase().includes("storytelling"));
  return { povCreators, storytellingCreators };
};

// New Watchlist: compare analyzed_at date
export const getNewWatchlist = (history) => {
  const today = new Date().toDateString();
  return history.filter(h => new Date(h.analyzed_at).toDateString() === today);
};

// Underpriced creators: high engagement but low followers
export const getUnderpricedCreators = (creators, followerThreshold = 20000, engagementThreshold = 0.1) =>
  creators.filter(c => (c.avg_likes || 0) / (c.followers || 1) > engagementThreshold && (c.followers || 0) < followerThreshold);

// Exploding creators: very high views per follower
export const getExplodingCreators = (creators, threshold = 2.0) =>
  creators.filter(c => (c.avg_views || 0) / (c.followers || 1) > threshold);

// High brand fit
export const getHighBrandFit = (creators, threshold = 80) =>
  creators.filter(c => (c.brand_fit || 0) >= threshold);

// New creators: created today
export const getNewCreators = (creators) => {
  const today = new Date().toDateString();
  return creators.filter(c => new Date(c.created_at).toDateString() === today);
};

// Emerging niches: niches growing >20%
export const getEmergingNiches = (creators, history) => {
  return creators.filter(c => {
    const prevCount = history.filter(h => h.niche === c.niche).length;
    const currentCount = creators.filter(cr => cr.niche === c.niche).length;
    return prevCount > 0 && (currentCount - prevCount) / prevCount > 0.2;
  });
};

// Viral hook changes: hooks appearing more often now
export const getViralHookChanges = (creators, history) => {
  return creators.filter(c => {
    const prevCount = history.filter(h => h.top_hook === c.top_hook).length;
    const currentCount = creators.filter(cr => cr.top_hook === c.top_hook).length;
    return currentCount > prevCount;
  });
};
